import React from 'react';
import MulSelector from '../TeaSelector/MultipleSelector';
import { useIntl } from 'umi';

export default function GametypeAll(props: any) {
  const { onConfirm, value = [] } = props;

  const { formatMessage } = useIntl();

  const gameType = [
    {
      value: 'Data acquisition',
      text: formatMessage({ id: 'dbi-sm-filter-acquisition' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-acquisition' }),
    },
    {
      value: 'Data crawling',
      text: formatMessage({ id: 'dbi-sm-filter-crawling' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-crawling' }),
    },
  ];

  const handleChange = (values: string[] | string) => {
    if (onConfirm instanceof Function) {
      onConfirm(values);
    }
  };

  return (
    <MulSelector
      value={typeof value === 'string' ? [] : value}
      options={gameType}
      buttonName={formatMessage({ id: 'dbi-sm-filter-servicetype' })}
      onChange={handleChange}
      style={{ width: '271px' }}
    />
  );
}
